import { useSelector } from 'react-redux'

/**
 * A hook, that extracts state from reducer, decides current theme and returns current theme object
 * */
export function useCurrentTheme() {
	const settings = useSelector((state) => state.preferences.dataNew)
	const { theme } = settings.common

	return settings[theme]
}

export function useCommonTheme() {
	const settings = useSelector((state) => state.preferences.dataNew)

	return settings.common
}

export function useActionsColors() {
	const settings = useSelector((state) => state.preferences.dataNew)
	const { theme: currentTheme } = settings.common
	const theme = settings[currentTheme].actions

	return function (name, index, isAllIn) {
		name = name.toLowerCase().split(' ')[0]

		if (isAllIn) {
			return theme.allin
		}

		// bet and raise have equal colors
		if (name.startsWith('b') || name.startsWith('r')) {
			return theme.raise[index]
		}

		return theme[name]
	}
}

export function usePresetsColors(index) {
	const settings = useSelector((state) => state.preferences.dataNew)
	const theme = settings.presets[index].value.actions

	return function (name, index, isAllIn) {
		name = name.toLowerCase().split(' ')[0]

		if (isAllIn) {
			return theme.allin
		}

		// bet and raise have equal colors
		if (name.startsWith('bet') || name.startsWith('raise')) {
			return theme.raise[index]
		}

		return theme[name]
	}
}

export function usePresets() {
	const settings = useSelector((state) => state.preferences.dataNew)

	return settings.presets
}

export function useActionsHotKey() {
	const settings = useSelector((state) => state.preferences.dataNew)
	const { theme: currentTheme } = settings.common
	const theme = settings[currentTheme].hotkeys['Board actions']

	return function (name, index, isAllIn) {
		name = name.toLowerCase().split(' ')[0]

		if (isAllIn) {
			return theme.allin
		}

		// bet and raise have equal colors
		if (name.startsWith('bet') || name.startsWith('raise')) {
			return theme.raise[index]
		}

		if (name.startsWith('call') || name.startsWith('check')) {
			return theme.check
		}

		return theme[name]
	}
}
